import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FontIcon from 'components/FontIcon';
import Link from 'components/Link';
import classes from './NavD.module.scss';

class NavD extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showLinks: false,
    };

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    const { showLinks } = this.state;
    this.setState({ showLinks: !showLinks });
  }

  render() {
    const { header, nodes } = this.props;
    const { showLinks } = this.state;

    return (
      nodes && nodes.length > 0 &&
        <div>

          {/* Desktop Component */}
          <div className={classes.desktop}>
            {
              header
              && <h4
                className={classes.header}
                dangerouslySetInnerHTML={{ __html: header }}
              />
}
            <hr />
            <ul>
              {
                nodes.map((node, index) => (
                  <li key={index}>
                    <Link
                      href={node.url}
                      target={node.linkTarget}
                    >
                      <span dangerouslySetInnerHTML={{ __html: node.title }} />
                      <FontIcon className={classes.rightArrow} icon='far fa-chevron-right' />
                    </Link>
                  </li>
                ))
              }
            </ul>
          </div>

          {/* Mobile Component */}
          <div className={classes.mobile}>
            <button aria-label={header} onClick={this.onClick} className={classes.headerButton} type='button'>
              {header &&
                <span
                  className={classes.header}
                  dangerouslySetInnerHTML={{ __html: header }}
                />}
              <FontIcon
                className={classes.icon}
                icon={showLinks ? 'far fa-minus-circle' : 'far fa-plus-circle'}
              />
            </button>
            {showLinks &&
              <ul>
                {
                  nodes.map((node, index) => (
                    <li key={index}>
                      <Link
                        className={classes.listButton}
                        href={node.url}
                        target={node.linkTarget}
                      >
                        <span dangerouslySetInnerHTML={{ __html: node.title }} />
                      </Link>
                    </li>
                  ))
                }
              </ul>}
          </div>

        </div>
    );
  }
}

NavD.propTypes = {
  /**
   * Text displays at the top of the component
  */
  header: PropTypes.string,
  /**
   * A list of links that display directly below the header
  */
  nodes: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
    linkTarget: PropTypes.string,
  })),
};

export default NavD;
